// extracted by mini-css-extract-plugin
export var actionText = "_lp-4";
export var container = "_lp-0";
export var leftSection = "_lp-1";
export var rightSection = "_lp-2";
export var settingsButton = "_lp-6";
export var settingsIcon = "_lp-7";
export var shortcut = "_lp-5";
export var shortcutGroup = "_lp-3";